// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumOwnerReferenceKind } from './EnumOwnerReferenceKind';
import {
  EnumOwnerReferenceKindFromJSON,
  EnumOwnerReferenceKindFromJSONTyped,
  EnumOwnerReferenceKindToJSON,
  EnumOwnerReferenceKindToJSONTyped,
} from './EnumOwnerReferenceKind';

/**
 *
 * @export
 * @interface ResponseOwnerIdentifier
 */
export interface ResponseOwnerIdentifier {
  /**
   *
   * @type {number}
   * @memberof ResponseOwnerIdentifier
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseOwnerIdentifier
   */
  identifier?: string;
  /**
   *
   * @type {EnumOwnerReferenceKind}
   * @memberof ResponseOwnerIdentifier
   */
  kind?: EnumOwnerReferenceKind;
}

/**
 * Check if a given object implements the ResponseOwnerIdentifier interface.
 */
export function instanceOfResponseOwnerIdentifier(
  value: object,
): value is ResponseOwnerIdentifier {
  return true;
}

export function ResponseOwnerIdentifierFromJSON(
  json: any,
): ResponseOwnerIdentifier {
  return ResponseOwnerIdentifierFromJSONTyped(json, false);
}

export function ResponseOwnerIdentifierFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseOwnerIdentifier {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    identifier: json['identifier'] == null ? undefined : json['identifier'],
    kind:
      json['kind'] == null
        ? undefined
        : EnumOwnerReferenceKindFromJSON(json['kind']),
  };
}

export function ResponseOwnerIdentifierToJSON(
  json: any,
): ResponseOwnerIdentifier {
  return ResponseOwnerIdentifierToJSONTyped(json, false);
}

export function ResponseOwnerIdentifierToJSONTyped(
  value?: ResponseOwnerIdentifier | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    identifier: value['identifier'],
    kind: EnumOwnerReferenceKindToJSON(value['kind']),
  };
}
